import React from 'react'

// @material-ui/core components
import {makeStyles, withStyles} from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import CircularProgress from '@material-ui/core/CircularProgress';
import LockIcon from '@material-ui/icons/Lock';
import Snackbar from '@material-ui/core/Snackbar';
import LinearProgress from '@material-ui/core/LinearProgress';
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
// core components
import Grid from "@material-ui/core/Grid";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

// import styles from "assets/jss/material-kit-pro-react/views/loginPage.js";
import styles from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";
import validate from "../utils/validate";

import storage from "../utils/storage";
import store from "../redux/Store";

import {bingImage, login} from "../utils/request";
import BaseHeader from "./BaseView/BaseHeader";
import BaseFooter from "./BaseView/BaseFooter";
import {withSnackbar} from "notistack";
import Info from "../components/Typography/Info";
import Rose from "../components/Typography/Rose";
import Warning from "../components/Typography/Warning";
import Primary from "../components/Typography/Primary";
import BaseLayout from "./BaseView/BaseLayout";
import Divider from "@material-ui/core/Divider";
import intl from 'react-intl-universal';


const useStyles = styles;

const formRule = {
	email: {
		validator(rule, value, callback, source, options) {
			/* callback必须执行一次,带参数为错误信息,不带参数为正确 */
			if (value) {
				if (!(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value))) {
					callback({
						errMsg:  intl.get('enter_email_error'),
						value,
						errStatus: true
					});
				} else {
					callback({
						errMsg: " ",
						value,
						errStatus: false,
						successStatus: true
					});
				}
			} else {
				callback({
					errMsg: intl.get('enter_email'),
					value,
					errStatus: true
				});

			}
		}
	},
	password: {
		validator(rule, value, callback, source, options) {
			/* callback必须执行一次,带参数为错误信息,不带参数为正确 */
			if (value) {
				if (value.length > 100) {
					callback({
						errMsg: intl.get('password_long'),
						value,
						errStatus: true
					});
				} else {

					callback({
						errMsg: " ",
						value,
						errStatus: false,
						successStatus: true
					});
				}

			} else {
				callback({
					errMsg: intl.get('enter_password'),
					value,
					errStatus: true
				});
			}
		}
	},
	vertify: {
		validator(rule, value, callback, source, options) {
			/* callback必须执行一次,带参数为错误信息,不带参数为正确 */
			// console.log('vertify: ' + value)
			if (value) {
				if (value.length > 10) {
					callback({
						errMsg: intl.get('verification_too_long'),
						value,
						errStatus: true
					});
				} else {
					callback({
						errMsg: " ",
						value,
						errStatus: false,
						successStatus: true
					});
				}
			} else {
				callback({
					errMsg: intl.get('enter_verification'),
					value,
					errStatus: true
				});
			}
		}
	},
};

class Login extends React.Component {

	constructor(props) {
		super(props);
		const tips = this.props.match.params.tips;
		this.state = {
			cardAnimaton: "cardHidden",
			flag: '',
			email: {
				value: '',
				errStatus: false,
				successStatus: false,
				errMsg: ' '
			},
			password: {
				value: '',
				errStatus: false,
				successStatus: false,
				errMsg: ' '
			},
			vertify: {
				value: '',
				errStatus: false,
				successStatus: false,
				errMsg: ' '
			},
			inLogin: false,
		};


		if (tips === '700') {
			this.props.enqueueSnackbar(intl.get('login_tips_1'), {variant: 'info'})
		} else if (tips === '701') {
			this.props.enqueueSnackbar(intl.get('login_tips_2'), {variant: 'success'})
		} else if (tips === '702') {
			this.props.enqueueSnackbar(intl.get('login_tips_3'), {variant: 'error'})
		} else if (tips === '704') {
			this.props.enqueueSnackbar(intl.get('login_tips_4'), {variant: 'info'})
		}

		this.handleChange = this.handleChange.bind(this);

		this.state.flag = this.updateVertifyImage();
		this.state.vertifyImage = global.constants.vertifyImageUrl + this.state.flag;
		this.checkUserStatus()
	}

	checkUserStatus = () => {
		if (storage.get('token') === null || storage.get('token') === undefined) {

		} else {
			this.props.history.push('/account');
		}
	};


	componentDidMount() {
		this.timeoutId = setTimeout(() => {
			this.setState({
				cardAnimaton: ""
			})
		}, 700)
	}

	updateVertifyImage = () => {
		let api = global.constants.vertifyImageUrl;
		const timestamp = Date.parse(new Date())
		const random = Math.ceil(Math.random() * 100);
		const flag = timestamp + random;
		api = api + flag;
		this.setState({
			vertifyImage: api,
			flag: flag
		})
		return flag

	}

	refreshImage = () => {
		this.setState({
			vertifyImage: ''
		}, () => {
			this.updateVertifyImage()
		})
	}

	subUserInfo = () => {
		let {email, password, vertify} = this.state;
		let errInfo = validate({
			descriptor: formRule,
			source: {
				email: email.value,
				password: password.value,
				vertify: vertify.value,
			}
		});
		errInfo.errors.forEach(item => {
			this.setState({
				[item.field]: item.message
			});
		});

		if (errInfo.isAllValid) {
			// console.log('验证成功');
			this.setState({
				inLogin: true
			}, () => {
				login(this.state.email.value, this.state.password.value, this.state.vertify.value, this.state.flag).then(response => {
					this.setState({
						inLogin: false
					}, () => {
						if (response.data.code === 0) {
							// alert('login success')
							// message.success('登录成功');
							storage.set("token", response.data.message)
							store.dispatch({
								type: "login"
							});
							this.props.history.push("/account")
						} else if (response.data.code === 1) {
							this.setState({
								vertify: {
									value: this.state.vertify.value,
									errStatus: true,
									errMsg: intl.get('verification_error')
								},
							})
							// message.error(response.data.message);
						} else {
							this.setState({
								email: {
									value: this.state.email.value,
									errStatus: true,
									errMsg: intl.get('login_error')
								},
								password: {
									value: this.state.password.value,
									errStatus: true,
									errMsg: intl.get('login_error')
								},
							})
						}
					});
					this.refreshImage()

				})
			})
		} else {
			// console.log('验证失败');
		}


	};


	handleChange = (event) => {
		const field = event.target.id;
		if (field === 'email') {
			this.setState({email: Object.assign(this.state.email, {value: event.target.value})});
		} else if (field === 'password') {
			this.setState({password: Object.assign(this.state.password, {value: event.target.value})});
		} else if (field === 'vertify') {
			this.setState({vertify: Object.assign(this.state.vertify, {value: event.target.value})});
		}
	};

	handleCheck = (event) => {
		console.log("event.target.id : " + event.target.id)
		if (event.target.id === 'email') {
			let errInfo = validate({
				descriptor: formRule,
				source: {
					email: event.target.value,
				},
				required: true
			});
			this.setState({email: errInfo.errors[0].message});
		} else if (event.target.id === 'password') {
			let errInfo = validate({
				descriptor: formRule,
				source: {
					password: event.target.value,
				},
				required: true
			});
			this.setState({password: errInfo.errors[1].message});
		} else if (event.target.id === 'vertify') {
			let errInfo = validate({
				descriptor: formRule,
				source: {
					vertify: event.target.value,
				},
				required: true
			});
			this.setState({vertify: errInfo.errors[2].message});
		}
	};

	render() {
		const cardAnimaton = this.state.cardAnimaton;


		const {classes} = this.props;

		const {email, password, vertify} = this.state;

		return (

			<BaseLayout>
				<GridContainer justify="center">
					<GridItem xs={12} sm={12} md={4}>
						<Card className={classes[cardAnimaton]}>
							<form className={classes.form}
								// onSubmit={this.subUserInfo}
							>
								<CardHeader color="primary" className={classes.cardHeader}>
									<h4>{intl.get('login')}</h4>
								</CardHeader>
								<p className={classes.description + " " + classes.textCenter}
								   style={{marginTop: '12px'}}
								>
									{intl.get('email')}&nbsp;{intl.get('login')}
								</p>
								<CardBody signup>

									<CustomInput
										error={email.errStatus}
										success={email.successStatus}
										labelHelper={email.errMsg}

										labelText={intl.get('email')}
										id="email"
										required
										formControlProps={{
											fullWidth: true
										}}
										inputProps={{
											value: `${email.value}`,
											onChange: this.handleChange,
											onBlur: this.handleCheck,

											type: "email",
											endAdornment: (
												<InputAdornment position="end">
													<Email
														className={classes.inputIconsColor}/>
												</InputAdornment>
											),
											autoComplete: "off"
										}}
									/>


									<CustomInput
										error={password.errStatus}
										success={password.successStatus}
										labelHelper={password.errMsg}

										labelText={intl.get('password')}
										id="password"
										formControlProps={{
											fullWidth: true
										}}

										inputProps={{
											value: `${password.value}`,
											onChange: this.handleChange,
											onBlur: this.handleCheck,
											type: "password",
											endAdornment: (
												<InputAdornment position="end">
													<LockIcon
														className={classes.inputIconsColor}>
													</LockIcon>
												</InputAdornment>
											),
											autoComplete: "off"
										}}
									/>

									<CustomInput
										error={vertify.errStatus}
										success={vertify.successStatus}
										labelHelper={vertify.errMsg}
										labelText={intl.get('verification')}
										id="vertify"
										required
										formControlProps={{
											fullWidth: true
										}}
										inputProps={{
											value: `${vertify.value}`,
											onChange: this.handleChange,
											onBlur: this.handleCheck,
											type: "text",
											endAdornment: (
												<img id="captcha_img" alt={intl.get('update_verification')}
													 title={intl.get('update_verification')}
													 style={{
														 minWidth: '110px',
														 minHeight: '40px'
													 }}
													 onClick={this.refreshImage}
													 src={this.state.vertifyImage}
												/>
											)
										}}
									/>
								</CardBody>

								<CardFooter className={classes.cardFooter}
											style={{marginTop: '12px'}}
								>
									<Button color="primary"
										// type="submit"
											size={'lg'}
											onClick={this.subUserInfo}
											fullWidth
											disabled={this.state.inLogin}
									>
										{
											this.state.inLogin ?
												<CircularProgress
													style={{width: '100%', height: '100%'}}
													color={'#fff'}/>
												:
												<span>{intl.get('login')}</span>
										}

									</Button>
								</CardFooter>
							</form>
							<GridItem container item xs={12} spacing={3}
									  justify="center"
									  alignItems="center">
								<GridItem xs={6}>
									<Button simple color="primary" size="small"
											style={{width: '100%'}}
											href={'/signUp'}
									>
										{intl.get('registered')}
									</Button>
								</GridItem>
								<GridItem xs={6}>
									<Button simple color="primary" size="small"
											style={{width: '100%'}}
											href={'/password_forget'}
									>
										{intl.get('forget_password')}</Button>
								</GridItem>
							</GridItem>
							<Divider />
							<GridItem container item xs={12}
									  alignItems="center"
									  style={{padding: '12px'}}
							>
								<Primary>
									{intl.get('resend_email_1')}<a href={'/email_re_attest'} style={{color: '#e91e63'}}>{intl.get('resend_email_2')}</a>
								</Primary>

							</GridItem>

						</Card>
					</GridItem>
				</GridContainer>
			</BaseLayout>
		)
	}
}

export default withStyles(useStyles)(withSnackbar(Login))
